import exDive from "assets/images/cargo-wrek.jpeg";
import whnDive from "assets/images/wreak.jpg";
import whnDive2 from "assets/images/ReefSite.jpg";
import activity1 from "assets/images/Activities.JPG";
import activity2 from "assets/images/Activites2.JPG";
//const imagesPrefix =
// "https://raw.githubusercontent.com/creativetimofficial/public-assets/master/material-design-system/presentation/sections";

export default [
  {
    title: "Explore diving in Sri Lanka",
    description:
      "Discover the vibrant underwater world of Sri Lanka — where warm tropical waters, colorful coral reefs, and fascinating shipwrecks await. From swimming with turtles in Hikkaduwa to exploring historic wrecks in Trincomalee, every dive offers a new adventur" +
      "Whether you're a beginner or a seasoned diver, our expert guides and top-tier equipment ensure a safe and unforgettable experience. Dive into crystal-clear waters and explore the hidden treasures beneath the surface.",
    items: [
      {
        image: `${exDive}`,
        //name: "Page Headers",
        //count: 1,
        route: "/sections/page-sections/page-headers",
      },
    ],
  },
  {
    title: "When to dive in Sri Lanka",
    description:
      "Sri Lanka offers year-round diving, thanks to its two distinct monsoon seasons that affect the east and west coasts at different times. This means there's always a perfect spot to dive, no matter the time of year.",
    items: [
      {
        image: `${whnDive}`,
        //name: "Navbars",
        //count: 4,
        route: "/sections/navigation/navbars",
      },
      {
        image: `${whnDive2}`,
        //name: "Nav Tabs",
        //count: 2,
        route: "/sections/navigation/nav-tabs",
      },
    ],
  },
  {
    title: "Activities",
    description:
      "Sri Lanka offers more than just diving — it’s an adventure both above and below the surface. Whether you're seeking thrills, relaxation, or cultural discovery, there’s something for everyone. \n Colorful reef dives Guided wreck dives",
    items: [
      {
        image: `${activity1}`,
        //name: "Newsletters",
        //count: 6,
        //pro: true,
      },
      {
        image: `${activity2}`,
        //name: "Contact Sections",
        //count: 8,
        //pro: true,
      },
    ],
  },
  /** {
     title: "Attention Catchers",
     description: "20+ Fully coded components that popup from different places of the screen",
     items: [
       {
         image: `${imagesPrefix}/alerts.jpg`,
         name: "Alerts",
         count: 4,
         route: "/sections/attention-catchers/alerts",
       },
       {
         image: `${imagesPrefix}/toasts.jpg`,
         name: "Notifications",
         count: 3,
         pro: true,
       },
       {
         image: `${imagesPrefix}/popovers.jpg`,
         name: "Tooltips & Popovers",
         count: 2,
         route: "/sections/attention-catchers/tooltips-popovers",
       },
       {
         image: `${imagesPrefix}/modals.jpg`,
         name: "Modals",
         count: 5,
         route: "/sections/attention-catchers/modals",
       },
     ],
   },*/
  /*{
    title: "Elements",
    description: "80+ carefully crafted small elements that come with multiple colors and shapes",
    items: [
      {
        image: `${imagesPrefix}/buttons.jpg`,
        name: "Buttons",
        count: 6,
        route: "/sections/elements/buttons",
      },
      {
        image: `${imagesPrefix}/avatars.jpg`,
        name: "Avatars",
        count: 2,
        route: "/sections/elements/avatars",
      },
      {
        image: `${imagesPrefix}/dropdowns.jpg`,
        name: "Dropdowns",
        count: 2,
        route: "/sections/elements/dropdowns",
      },
      {
        image: `${imagesPrefix}/switch.jpg`,
        name: "Toggles",
        count: 2,
        route: "/sections/elements/toggles",
      },
      {
        image: `${imagesPrefix}/social-buttons.jpg`,
        name: "Social Buttons",
        count: 2,
        pro: true,
      },
      {
        image: `${imagesPrefix}/breadcrumbs.jpg`,
        name: "Breadcrumbs",
        count: 1,
        route: "/sections/elements/breadcrumbs",
      },
      {
        image: `${imagesPrefix}/badges.jpg`,
        name: "Badges",
        count: 3,
        route: "/sections/elements/badges",
      },
      {
        image: `${imagesPrefix}/progress.jpg`,
        name: "Progress Bars",
        count: 4,
        route: "/sections/elements/progress-bars",
      },
      {
        image: `${imagesPrefix}/tables.jpg`,
        name: "Tables",
        count: 3,
        pro: true,
      },
      {
        image: `${imagesPrefix}/typography.jpg`,
        name: "Typography",
        count: 2,
        route: "/sections/elements/typography",
      },
    ],
  },*/
];
